<span bottom
      [class]="'bar-button'"
      [pTooltip]="buttonTitle|translate"
      (click)="op.toggle($event)">
    <i *ngIf="inProgressCount>0" [class]="'bar-button-ico fa-solid fa-clock-rotate-left'" pBadge
       [value]="inProgressCount"></i>
    <i *ngIf="inProgressCount===0" [class]="'bar-button-ico fa-solid fa-clock-rotate-left'"></i>
    <div class="bar-button-text">{{buttonTitle|translate}}</div>
  </span>
<p-overlayPanel #op [showCloseIcon]="true" [style.width]="'70vw'" [style.minWidth]="'70vw'" [style.maxWidth]="'70vw'"
                [dismissable]="!detailDialogVisible" [styleClass]="'top-overlay'" >
  <ng-template pTemplate>
    <app-report-tasks-table #taskTable class="archive-tasks-button" [transPartKey]="transPartKey"
                            [origins]="origins" [(detailDialogVisible)]="detailDialogVisible"
                            (detailDialogVisibleChange)="updateOp($event)">
    </app-report-tasks-table>
  </ng-template>
</p-overlayPanel>
